import { render } from "./uploadMedia.vue?vue&type=template&id=2b4dc985&scoped=true"
import script from "./uploadMedia.vue?vue&type=script&lang=js"
export * from "./uploadMedia.vue?vue&type=script&lang=js"

import "./uploadMedia.vue?vue&type=style&index=0&id=2b4dc985&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4dc985"]])

export default __exports__